var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-dialog",
    {
      attrs: { "max-width": "790", width: "530" },
      model: {
        value: _vm.uploadErrorDialog,
        callback: function($$v) {
          _vm.uploadErrorDialog = $$v
        },
        expression: "uploadErrorDialog"
      }
    },
    [
      _c(
        "v-card",
        { staticClass: "delete-modal" },
        [
          _c(
            "div",
            { staticClass: "v-card-title-text-container" },
            [
              _c("CloudSVG", { staticClass: "cloud-style" }),
              _vm._v(" "),
              _c(
                "div",
                [
                  _c("v-card-title", { staticClass: "headline" }, [
                    _vm._v("Ups...")
                  ]),
                  _vm._v(" "),
                  _c("v-card-text", [
                    _vm._v(
                      "\n          " +
                        _vm._s(_vm.$t("PhotoUploadError")) +
                        "\n          "
                    ),
                    _c("br"),
                    _vm._v(" "),
                    _c("br"),
                    _vm._v(
                      "\n          " +
                        _vm._s(_vm.specificErrorMessage) +
                        "\n        "
                    )
                  ])
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-card-actions",
            [
              _c("div", { staticClass: "flex-grow-1" }),
              _vm._v(" "),
              _c(
                "v-btn",
                {
                  staticClass: "cancel-button",
                  attrs: { ripple: false, text: "" },
                  on: { click: _vm.closeDialog }
                },
                [_vm._v(_vm._s(_vm.$t("Cancel")))]
              ),
              _vm._v(" "),
              _c(
                "v-btn",
                {
                  staticClass: "delete-button",
                  attrs: { text: "" },
                  on: { click: _vm.closeDialog, change: _vm.onFileChange }
                },
                [
                  _c("input", {
                    staticClass: "photo-input",
                    attrs: { type: "file", accept: "image/*", title: "" }
                  }),
                  _vm._v("\n        " + _vm._s(_vm.$t("TryAgain")) + "\n      ")
                ]
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5117d4dc", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5117d4dc","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Home/Forms/_SpecialTabs/Photos/PhotoUploadError.vue
// module id = null
// module chunks = 